import { RESULTS_ALL_CUTS } from "./rosterState"

import type { ClassroomResults } from "@/types"

/**
 * Which Resultados scope is in effect — one rule for the two readers of
 * `?cut=`: the Resultados section and the roster rows under it (PRD-61).
 * If they resolved it separately, a stale or foreign `?cut=5` could select
 * "Todo el curso" in the section while the rows asked the API for cut 5.
 */

/** The default scope: the cut that contains today, else the whole course. */
export function defaultResultsKey(results: ClassroomResults | undefined): string {
  const current = results?.current_cut
  return current !== null &&
    current !== undefined &&
    results?.cuts.some((c) => c.number === current)
    ? String(current)
    : RESULTS_ALL_CUTS
}

/** The URL's `?cut=` when it names the whole course or a cut that exists;
 *  otherwise the default. */
export function selectedResultsKey(
  results: ClassroomResults | undefined,
  cutParam: string | null,
): string {
  if (cutParam === RESULTS_ALL_CUTS) return RESULTS_ALL_CUTS
  if (cutParam !== null && results?.cuts.some((c) => String(c.number) === cutParam)) {
    return cutParam
  }
  return defaultResultsKey(results)
}
